import { render, staticRenderFns } from "./demo-detail.vue?vue&type=template&id=74cffc8c&scoped=true&"
import script from "./demo-detail.vue?vue&type=script&lang=js&"
export * from "./demo-detail.vue?vue&type=script&lang=js&"
import style0 from "./demo-detail.vue?vue&type=style&index=0&id=74cffc8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cffc8c",
  null
  
)

export default component.exports